export default [
  {
    title: 'Operações',
    icon: 'SettingsIcon',
    action: 'read',
    resource: 'Operações',
    children: [
      // "Pedidos de Vendas" foi promovido a menu top-level próprio ("Pedidos")
      // — ver navigation/vertical/pedidos/pedidos.js.
      // {
      //     title: 'Pedidos Padrão',
      //     route: 'pedidos-vendas-padrao',
      //     icon: 'CircleIcon',
      //     action: 'read',
      //     resource: 'PedidosVendaPadrao',
      // },
      {
        title: 'Painel Pic',
        route: 'apps-painel-pic-list',
        icon: 'CircleIcon',
        action: 'read',
        resource: 'PainelPic',
        tenantPref: 'picAtivo',
      },
      {
        title: 'Pic',
        route: 'apps-pic-list',
        icon: 'CircleIcon',
        action: 'read',
        resource: 'Pic',
        tenantPref: 'picAtivo',
      },
    ],
  },
];
